import { fetchApi, paginatedSchema } from "./admin-api/internal";
import { discoverableClubSchema } from "./schemas/club";

export const api = {
	clubs: {
		friends: (params?: { q?: string; page?: number; type?: string; is_public?: boolean }) => {
			const search = new URLSearchParams();
			if (params?.q) search.set("q", params.q);
			if (params?.page) search.set("page", params.page.toString());
			if (params?.type) search.set("type", params.type);
			if (params?.is_public !== undefined) search.set("is_public", params.is_public.toString());
			const qs = search.toString();
			return fetchApi(
				`/clubs/friends${qs ? `?${qs}` : ""}`,
				paginatedSchema(discoverableClubSchema),
			);
		},
	},

	explore: {
		clubs: (params?: { q?: string; page?: number; ranked_for?: string; explain?: boolean }) => {
			const search = new URLSearchParams();
			if (params?.q) search.set("q", params.q);
			if (params?.page) search.set("page", params.page.toString());
			if (params?.ranked_for) search.set("ranked_for", params.ranked_for);
			if (params?.explain) search.set("explain", params.explain.toString());
			const qs = search.toString();
			return fetchApi(
				`/public/explore/clubs${qs ? `?${qs}` : ""}`,
				paginatedSchema(discoverableClubSchema),
			);
		},
	},
};
